import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import 'bootstrap-icons/font/bootstrap-icons.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import store from './store'
import { injectStore } from './api/httpClient'

const container = document.getElementById('root')
const root = createRoot(container)

injectStore(store)

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
)

reportWebVitals()
